import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
type AnyResourceData = any;

// IMPORTANT - spreading resources can invoke getters, cloning will safely duplicate/edit resource
export const safeCloneResource = (
	resource: RouteResource<AnyResourceData>,
	amendments: Partial<RouteResource<AnyResourceData>> = {},
): RouteResource<AnyResourceData> =>
	// @ts-expect-error - TS2322 - Type 'Partial<RouteResource<any>>' is not assignable to type 'RouteResource<any>'.
	resource && // IMPORTANT - resources can be falsy in SSR "routes" build
	// oxlint-disable-next-line typescript/consistent-type-assertions
	Object.defineProperties({} as Partial<RouteResource<AnyResourceData>>, {
		...Object.getOwnPropertyDescriptors(resource),
		...Object.getOwnPropertyDescriptors(amendments),
	});

// IMPORTANT - conditional resource is not type-safe, use only in non-specific cases such as routes
export const resourceWithCondition = (
	conditionGetter: () => boolean,
	itemTrue: RouteResource<AnyResourceData>,
	itemFalse: RouteResource<AnyResourceData> = safeCloneResource(itemTrue, {
		getKey: () => 'DEGENERATE_KEY',
		getData: () => null,
		maxAge: Number.MAX_SAFE_INTEGER,
	}),
): RouteResource<AnyResourceData> =>
	// @ts-expect-error - TS2740 - Type '{}' is missing the following properties from type 'RouteResource<any>': type, getKey, maxAge, getData, and 3 more.
	itemTrue && // IMPORTANT - resources can be falsy in SSR "routes" build
	Object.defineProperties(
		{},
		Object.fromEntries(
			[...Object.keys(itemTrue), ...Object.keys(itemFalse)]
				.filter((v, i, a) => a.indexOf(v) === i)
				.map((key) => [
					key,
					{
						configurable: false,
						enumerable: true,
						// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'RouteResource<any>'.
						get: () => (conditionGetter() ? itemTrue[key] : itemFalse[key]),
					},
				]),
		),
	);

export const browserOnlyResourceWithCondition = <T,>(
	conditionGetter: () => boolean,
	resource: RouteResource<T>,
): RouteResource<T> =>
	resource && {
		...resource,
		get isBrowserOnly() {
			return !!conditionGetter();
		},
	};
